import { gql } from '@apollo/client';

export const AI_UPDATE_PROMPT = gql`
    mutation UpdatePrompt( $input: UpdatePromptInput! ) {
        updatePrompt( input: $input ) {
            id
            companyId
            label
            prompt
            sql
            isSaved
            reportCount
            createdAt
            updatedAt
        }
    }
`;

export default AI_UPDATE_PROMPT;
